// TankView shared inline-style objects. See TSP-142.
// Mirrors the styles MWOPage and UploadPage have been redefining inline.
// Spread (`{...btnPrimary, width: "60%"}`) when a variant is needed.

import { colors } from "./theme";

export const cardStyle = {
  background: colors.cardBg,
  borderRadius: 12,
  padding: "16px 14px",
  marginBottom: 12,
  border: `1px solid ${colors.border}`,
};

export const labelStyle = {
  fontSize: 14,
  fontWeight: 600,
  color: colors.text,
  marginBottom: 6,
  display: "block",
};

// 16px font prevents iOS auto-zoom on focus.
export const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  fontSize: 16,
  border: `1px solid ${colors.border}`,
  borderRadius: 8,
  outline: "none",
  boxSizing: "border-box",
  WebkitAppearance: "none",
  MozAppearance: "none",
};

// 52px minHeight clears the iOS 48px minimum touch target.
export const btnPrimary = {
  width: "100%",
  padding: "16px 0",
  fontSize: 16,
  fontWeight: 600,
  color: "#fff",
  background: colors.primary,
  border: "none",
  borderRadius: 10,
  cursor: "pointer",
  minHeight: 52,
  WebkitTapHighlightColor: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
};

export const btnSecondary = {
  width: "100%",
  padding: "14px 0",
  fontSize: 15,
  fontWeight: 500,
  color: colors.text,
  background: "#fff",
  border: `1px solid ${colors.border}`,
  borderRadius: 10,
  cursor: "pointer",
  minHeight: 52,
  WebkitTapHighlightColor: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
};

export const btnDisabled = { ...btnPrimary, opacity: 0.4, cursor: "not-allowed" };

// Sticky bottom nav bar with safe-area padding for notched devices.
export const bottomNav = {
  position: "sticky",
  bottom: 0,
  left: 0,
  right: 0,
  display: "flex",
  gap: 12,
  padding: "12px 0",
  paddingBottom: "calc(12px + env(safe-area-inset-bottom, 0px))",
  background: colors.pageBg,
  marginTop: 16,
  zIndex: 10,
};

const styles = { cardStyle, labelStyle, inputStyle, btnPrimary, btnSecondary, btnDisabled, bottomNav };
export default styles;
